/* eslint-disable jsx-a11y/label-has-associated-control */
import { TextInput } from '@/domains/AuthModal/components/Inputs';
import { css } from '@emotion/react';
import { useState } from 'react';
import { Dropdown } from '../Dropdown/Dropdown';
import { LinkIcon } from '../icons/LinkIcon';
import {
  AddButton,
  ButtonWrapper,
  CancelButton,
  Input,
  InputLabel,
  PopperToolbar,
  PopperWrapper,
  ToolbarItem,
} from './TextEditor.styles';

export function LinkToolbar(props: any): JSX.Element {
  const { onChange, currentState } = props;

  const [itemRef, setItemRef] = useState<HTMLButtonElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [labelValue, setLabelValue] = useState('');
  const [urlValue, setUrlValue] = useState('');
  function handleLinkClick() {
    if (currentState.link) {
      onChange();
      return;
    }
    setLabelValue(currentState.selectionText);
    setUrlValue(currentState.link);
    setExpanded(!expanded);
  }

  function handleAdd() {
    onChange('link', labelValue, urlValue);
    setUrlValue('');
    setLabelValue('');
    setExpanded(false);
  }
  return (
    <Dropdown
      onClose={() => setExpanded(false)}
      expanded={expanded}
      buttonReference={itemRef}
      buttonElement={() => (
        <ToolbarItem
          $active={Boolean(currentState.link)}
          ref={setItemRef}
          onClick={handleLinkClick}
        >
          <LinkIcon />
        </ToolbarItem>
      )}
      matchButtonWidth={false}
      popperElement={() => (
        <PopperWrapper $height={244} $width={300}>
          <PopperToolbar>
            <InputLabel htmlFor="label">Label:</InputLabel>
            <Input
              value={labelValue}
              id="label"
              name="label"
              onChange={(e) => setLabelValue(e.target.value)}
              disabled={!expanded}
            />
            <InputLabel htmlFor="url">Link:</InputLabel>
            <Input
              value={urlValue}
              id="url"
              name="url"
              onChange={(e) => setUrlValue(e.target.value)}
              disabled={!expanded}
            />
            <ButtonWrapper>
              <AddButton
                disabled={Boolean(!urlValue) || !expanded}
                onClick={handleAdd}
              >
                Add
              </AddButton>
              <CancelButton
                onClick={() => setExpanded(false)}
                disabled={!expanded}
              >
                Cancel
              </CancelButton>
            </ButtonWrapper>
          </PopperToolbar>
        </PopperWrapper>
      )}
    />
  );
}
